module.exports = __webpack_public_path__ + "static/img/img-6.f3b0931b.png";